var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgEyeglass = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1301 16.5822L23.6942 22.1496V22.154C24.1071 22.5814 24.1011 23.2608 23.6809 23.681C23.2606 24.1011 22.5811 24.107 22.1536 23.6942L16.5852 18.1268C12.3668 21.5237 6.22779 21.0282 2.60885 16.9989C-1.01009 12.9696 -0.844762 6.81402 2.98525 2.9847C6.81525 -0.844608 12.972 -1.00991 17.002 2.60838C21.0321 6.22666 21.5276 12.3645 18.1301 16.5822ZM7.15621 2.83005C4.17029 4.06651 2.22339 6.97962 2.22339 10.2109C2.22819 14.6206 5.80211 18.1944 10.2126 18.1998C13.4445 18.2002 16.3584 16.2541 17.5955 13.2689C18.8326 10.2837 18.1493 6.84734 15.8641 4.56231C13.579 2.27728 10.1421 1.59359 7.15621 2.83005Z",
    fill: "currentcolor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEyeglass);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/eyeglass.bc579c67e27eaa1ed5982ed11f02aac5.svg";